export default [
    {
        path: '/website/routes',
        props: true,
        component: () => import('@/views/WebsiteRoute'),
    },
];
